
import {
  Box,
  Button,
  Divider,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useState } from "react";
import axios from "axios";
import CommonBanner from "./Common";
import { useNavigate } from "react-router-dom";
import BASE_URL from "./constant";

const WhyDonation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [amount, setAmount] = useState("");
  const [purpose, setPurpose] = useState("General Help");
  const [loading, setLoading] = useState(false);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  const navigate = useNavigate();
  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      handleClose();

      const recId = Math.floor(100000 + Math.random() * 900000);

      const { data } = await axios.post(
        `${BASE_URL}/api/v1/razorpay/create`,
        {
          order_id: `DONATION_${Date.now()}`,
          amount: Math.max(Number(amount), 5),
          currency: "INR",
          payment_capture: 1,

          // Extra fields if your backend stores them
          donorName: name,
          mobile,
          email,
          purpose,
          receiptNo: recId,
        }
      );

      const orderData = data?.data;

      console.log("Order Response:", data);
      console.log("Order Data:", orderData);
      if (!orderData) {
        throw new Error("Unable to create payment order");
      }
      const options = {
        key: "rzp_live_TLESyErf0CNsFA", // Replace with your Razorpay key
        amount: orderData.amount,
        currency: orderData.currency,
        order_id: orderData.id,

        name: "LSSF Trust",
        description: "Donation",

        handler: async (response) => {
          try {
            await axios.post(`${BASE_URL}/api/v1/donation`, {
              receiptNo: recId,
              donorName: name,
              mobile,
              email,
              amount,
              purpose,

              razorpayOrderId: response.razorpay_order_id,
              razorpayPaymentId: response.razorpay_payment_id,
              razorpaySignature: response.razorpay_signature,

              paymentMode: "Online",
            });

            // Redirect to receipt page
            navigate(
              `/receipts?transactionId=${response.razorpay_payment_id}
                &orderId=${response.razorpay_order_id}
                &amount=${amount}
                &name=${encodeURIComponent(name)}
                &mobile=${mobile}
                &recId=${recId}
                &mode=Online
                &purpose=${encodeURIComponent(purpose)}
                ${email ? `&email=${email}` : ""}`
            );
          } catch (error) {
            console.error("Donation save error:", error);

            alert(
              "Payment was successful, but we couldn't save your donation record. Please contact support with your Payment ID: " +
              response.razorpay_payment_id
            );
          }
        },

        prefill: {
          name,
          email,
          contact: mobile,
        },

        method: {
          upi: true,
          card: true,
          netbanking: true,
          wallet: true,
        },

        theme: {
          color: "#6739B7",
        },

        modal: {
          ondismiss: () => {
            console.log("Payment popup closed");
          },
        },
      };
      console.log(options);
      const payment = new window.Razorpay(options);

      payment.on("payment.failed", function (response) {
        console.error(response.error);
        alert(response.error.description || "Payment Failed");
      });

      payment.open();
    } catch (error) {
      console.error(error);
      alert(error?.response?.data?.message || "Payment initialization failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <CommonBanner />
      <Box
        p={5}
        mx="auto"
        width={{ base: "90%", lg: "80%" }}
        mt={{ base: "-30%", lg: "-27%" }}
      >
        <Heading
          fontSize={{ base: "1.2rem", lg: "2rem" }}
          mb={5}
          textAlign="center"
        >
          Why Should You Donate to LSSF Trust?
        </Heading>

        <Stack spacing={5} mt={10}>
          {[
            {
              title: "1. Education for All",
              desc:
                "Education is a powerful tool for breaking the cycle of poverty. At LSSF Trust, we provide educational resources, scholarships, and support to underprivileged children, ensuring they have access to quality education. Your donation can help us create a brighter future for these young minds, equipping them with the skills and knowledge they need to succeed.",
            },
            {
              title: "2. Empowering Farmers with Modern Machinery",
              desc:
                "Farmers are the backbone of our nation, and at LSSF Trust, we strive to support them with modern agricultural machinery. By providing tools and equipment, we help farmers increase their productivity and income, leading to improved livelihoods and food security. Your donation can make a difference in the lives of countless farmers, helping them achieve sustainable growth.",
            },
            {
              title: "3. Women's Empowerment Through Skill Development",
              desc:
                "We believe in empowering women to achieve financial independence and self-sufficiency. Our programs provide women with training in skills like sewing and tailoring, allowing them to earn a livelihood and support their families. Additionally, we distribute blankets in villages to ensure warmth and comfort for all. Your contribution can help us continue to uplift and empower women in our communities.",
            },
            {
              title: "4. Encouraging Sports and Fitness",
              desc:
                "At LSSF Trust, we organize running championships and provide cash prizes to encourage physical fitness and sportsmanship among youth and adults. These events not only promote a healthy lifestyle but also foster a sense of community and achievement. Your donation can support these events and motivate more people to participate in sports and stay active.",
            },
            {
              title: "5. Supporting Girls' Marriages and Social Welfare",
              desc:
                "We believe in supporting young women and their families during important life events. Our programs provide financial assistance for girls' marriages, helping them start their new journey with dignity and support. Additionally, we offer various social welfare programs to assist those in need, ensuring that everyone has access to basic necessities and opportunities.",
            },
            {
              title: "6. A Holistic Approach to Community Development",
              desc:
                "LSSF Trust is dedicated to addressing the diverse needs of our communities through a holistic approach. From providing educational resources and agricultural support to empowering women and promoting health and wellness, our initiatives aim to create a positive and lasting impact.",
            },
          ].map((item, index) => (
            <Box key={index}>
              <VStack align="start" spacing={4}>
                <Heading fontSize={{ base: "1rem", lg: "1.2rem" }} color="black">
                  {item.title}
                </Heading>
                <Text fontSize={{ base: "1rem", lg: "1.2rem" }} color="gray.600">
                  {item.desc}
                </Text>
              </VStack>
              <Divider my={4} />
            </Box>
          ))}
        </Stack>

        <Box textAlign="center" mt={5}>
          <Button
            width={{ base: "50%", lg: "20%" }}
            backgroundColor={"#F56A02"}
            borderRadius={"full"}
            color={"white"}
            fontSize="1.2rem"
            p={6}
            _hover={{ background: "black" }}
            onClick={handleOpen}
          >
            Donate Now
          </Button>
        </Box>
      </Box>

      <Modal isOpen={isOpen} onClose={handleClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Make a Donation</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <form onSubmit={handleSubmit}>
              <VStack spacing={4} align="stretch">
                <Box>
                  <label>Name</label>
                  <input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                    placeholder="Enter your name"
                    style={{ width: "100%", padding: "10px", border: "1px solid #ccc" }}
                  />
                </Box>
                <Box>
                  <label>Mobile</label>
                  <input
                    type="text"
                    value={mobile}
                    onChange={(e) => setMobile(e.target.value)}
                    required
                    placeholder="Enter your mobile number"
                    style={{ width: "100%", padding: "10px", border: "1px solid #ccc" }}
                  />
                </Box>
                <Box>
                  <label>Email</label>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email"
                    style={{ width: "100%", padding: "10px", border: "1px solid #ccc" }}
                  />
                </Box>
                <Box>
                  <label>Amount</label>
                  <input
                    type="number"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    required
                    placeholder="Minimum ₹5"
                    style={{ width: "100%", padding: "10px", border: "1px solid #ccc" }}
                  />
                </Box>
                <Box>
                  <label>Purpose</label>
                  <select
                    value={purpose}
                    onChange={(e) => setPurpose(e.target.value)}
                    required
                    style={{
                      width: "100%",
                      padding: "10px",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                    }}
                  >
                    <option value="📚 Education Support">📚 Education Support</option>
                    <option value="🌾 Empowering Farmers">🌾 Empowering Farmers</option>
                    <option value="👩‍🦱 Women's Empowerment">👩‍🦱 Women's Empowerment</option>
                    <option value="⚽ Encouraging Sports">⚽ Encouraging Sports</option>
                    <option value="👰 Supporting Girls’ Marriages">
                      👰 Supporting Girls’ Marriages
                    </option>
                    <option value="🕉 Temple Construction">🕉 Temple Construction</option>
                    <option value="🤝 Holistic Development">
                      🤝 Holistic Development
                    </option>
                  </select>
                </Box>
                <Button
                  type="submit"
                  isLoading={loading}
                  backgroundColor="#6739B7"
                  color="white"
                  _hover={{ background: "black" }}
                >
                  {loading ? "Processing..." : "Pay Now"}
                </Button>
              </VStack>
            </form>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default WhyDonation;
